const Config = Object.freeze({
  baseUrl: "https://api.lennastyle.com/v1",
});

export default Config;
